import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import Header from './components/Header';
import Hero from './components/Hero';
import AboutConcept from './components/AboutConcept';
import FormatSpace from './components/FormatSpace';
import FranchiseFormats from './components/FranchiseFormats';
import Investments from './components/Investments';
import FranchiseIncludes from './components/FranchiseIncludes';
import InvestorMarket from './components/InvestorMarket';
import RevenueSources from './components/RevenueSources';
import FinancialModel from './components/FinancialModel';
import InvestorExit from './components/InvestorExit';
import Scaling from './components/Scaling';
import Gallery from './components/Gallery';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';
import LegalNotice from './components/LegalNotice';
import PrivacyPolicy from './components/PrivacyPolicy';
import CookiesPolicy from './components/CookiesPolicy';
import TermsOfUse from './components/TermsOfUse';
import SEO from './components/SEO';
import LanguageRedirect from './components/LanguageRedirect';
import FranchiseGoals from './components/FranchiseGoals';
import WhyDifferent from './components/WhyDifferent';
import ExpandedFinancialScenario from './components/ExpandedFinancialScenario';
import MiniCTA from './components/MiniCTA';
import WhyThisMarket from './components/WhyThisMarket';
import ProofPoints from './components/ProofPoints';
import InvestorCTA from './components/InvestorCTA';
import UrgencyCTA from './components/UrgencyCTA';
import BottomCTA from './components/BottomCTA';
import StickyCTA from './components/StickyCTA';
import QuizSection from './components/QuizSection';
import ROICalculator from './components/ROICalculator';
import PresentationCTA from './components/PresentationCTA';

function HomePage() {
  return (
    <>
      <SEO />
      <Header />
      <main>
        {/* STEP 1: INTEREST/HOOK */}
        <Hero />
        <div className="section-divider" />
        
        {/* STEP 2: TRUST - Why This Market */}
        <WhyThisMarket />
        <div className="section-divider" />
        <ProofPoints />
        <MiniCTA />
        <div className="section-divider" />
        
        {/* STEP 3: WHY THIS BUSINESS */}
        <AboutConcept />
        <div className="section-divider" />
        <FormatSpace />
        <div className="section-divider" />
        
        {/* STEP 4: NUMBERS (MOST IMPORTANT) */}
        <FinancialModel />
        <UrgencyCTA />
        <div className="section-divider" />
        
        {/* INTERACTIVE ROI CALCULATOR */}
        <ROICalculator />
        <div className="section-divider" />
        
        {/* STEP 5: FORMATS */}
        <FranchiseFormats />
        <div className="section-divider" />
        
        {/* STEP 6: FRANCHISE COST */}
        <Investments />
        <div className="section-divider" />
        <FranchiseIncludes />
        <div className="section-divider" />
        
        {/* LEAD MAGNET: Presentation PDF */}
        <PresentationCTA />
        <div className="section-divider" />
        
        {/* INTERACTIVE QUIZ: Self-qualification */}
        <QuizSection />
        <MiniCTA />
        <div className="section-divider" />
        
        {/* STEP 7: WHAT INVESTOR GETS & Comparison */}
        <WhyDifferent />
        <div className="section-divider" />
        <RevenueSources />
        <div className="section-divider" />
        
        {/* CTA: Strong push after revenue model */}
        <BottomCTA />
        <div className="section-divider" />
        
        {/* STEP 8: EXPANDED SCENARIO */}
        <ExpandedFinancialScenario />
        <div className="section-divider" />
        
        {/* STEP 9: EXIT STRATEGY */}
        <InvestorExit />
        <div className="section-divider" />
        <Scaling />
        <div className="section-divider" />
        
        {/* Additional Context */}
        <FranchiseGoals />
        <div className="section-divider" />
        <InvestorMarket />
        <div className="section-divider" />
        <Gallery />
        <div className="section-divider" />
        
        {/* STEP 10: FINAL PUSH */}
        <InvestorCTA />
      </main>
      <Footer />
      <CookieConsent />
      <StickyCTA />
    </>
  );
}

function App() {
  return (
    <Router>
      <LanguageProvider>
        <div style={{ background: '#0A0B0F', minHeight: '100vh' }}>
          <Routes>
            {/* Root redirect to language-specific route */}
            <Route path="/" element={<LanguageRedirect />} />
            
            {/* Language-specific routes */}
            <Route path="/:lang" element={<HomePage />} />
            <Route path="/:lang/legal-notice" element={<LegalNotice />} />
            <Route path="/:lang/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/:lang/cookies-policy" element={<CookiesPolicy />} />
            <Route path="/:lang/terms-of-use" element={<TermsOfUse />} />
          </Routes>
        </div>
      </LanguageProvider>
    </Router>
  );
}

export default App;
